/**
 * Polyfills for older browsers, only included in the compat bundle.
 *
 * babel-polyfill handles standard JavaScript but doesn't include anything
 * DOM specific, so that must be loaded manually.
 *
 * Setting `configurable` and `writable` to true when defining properties to
 * let any potential polyfills included in third party libraries go through.
 */

// Internal, used below
function hasProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

// Make sure we're in a Browser-like environment before importing polyfills.
// This prevents issues during test and build.
if (typeof window !== 'undefined') {
  // window.fetch()
  // https://github.com/babel/babel/issues/9160
  require('whatwg-fetch');

  // DOM Level 4 features:
  // - Element manipulation: prepend/append/before/after/replaceWith/remove
  // - Element selection/checking: matches/closest/contains
  // - Element.toggleAttribute
  // - CustomEvent
  // - Various other things, see docs
  // https://github.com/WebReflection/dom4
  require('dom4');

  // IntersectionObserver
  // https://github.com/w3c/IntersectionObserver/tree/master/polyfill
  require('intersection-observer');

  // CSS object-fit via `data-object-fit`.
  require('./object-fit-polyfill');

  // Ensure picture tags can be targeted with CSS in IE.
  // Can't find a definitive answer to if this is actually required, but it's
  // so tiny it doesn't really matter. Picturefill includes it.
  document.createElement('picture');

  // IE11 has a prefix, assign it to the standard property name to make third
  // party libraries work.
  if (!window.crypto && window.msCrypto) {
    window.crypto = window.msCrypto;
  }

  // NodeList.forEach for IE.
  // https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
  if (window.NodeList && !hasProp(NodeList.prototype, 'forEach')) {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }

  // Node.isConnected for IE and old Edge.
  // https://developer.mozilla.org/en-US/docs/Web/API/Node/isConnected
  if (!hasProp(Node.prototype, 'isConnected')) {
    Object.defineProperty(Node.prototype, 'isConnected', {
      get() {
        /* eslint-disable no-bitwise */
        return (
          !this.ownerDocument ||
          !(
            this.ownerDocument.compareDocumentPosition(this) &
            this.DOCUMENT_POSITION_DISCONNECTED
          )
        );
      },
    });
  }
}
